import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8089";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = token;
  }
  return config;
});

export async function refreshAccessToken() {
  const role = localStorage.getItem("role");
  const refreshToken = localStorage.getItem("refreshToken");
  if (!role || !refreshToken) {
    return null;
  }
  const path =
    role === "MANAGER"
      ? "/api/v1/manager/token/refresh"
      : "/api/v1/supervisor/token/refresh";
  const response = await axios.get(`${API_BASE_URL}${path}`, {
    headers: { Authorization: refreshToken },
  });
  const accessToken = response.headers["accesstoken"];
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    return accessToken;
  }
  return null;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (!original || original._retry) {
      return Promise.reject(error);
    }
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      original._retry = true;
      try {
        const token = await refreshAccessToken();
        if (token) {
          original.headers = original.headers || {};
          original.headers.Authorization = token;
          return api(original);
        }
      } catch (e) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
